export default __webpack_public_path__ + "static/media/green.a848e404.svg";